import { Button, Card, Form, InputNumber } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { useEffect, useState } from 'react';
import { updateConfigs } from '../../../../appRedux/actions';
import { buttonLabel, cardConfig, formConfig } from '../../../../constants';

export const SettingStrikerAppointmentModal = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { configs } = useSelector((state) => state.configs);
  const [form] = Form.useForm();
  const { setShowModal } = useCustomModal();
  const [isLoading, setIsLoading] = useState(false);
  const [configId, setConfigId] = useState();
  const [response, setResponse] = useState();

  useEffect(() => {
    setConfigId(configs?.id);
  }, [configs?.id]);

  useEffect(() => {
    if ([200, 201].includes(response)) {
      setShowModal(false);
      if (onSuccess) onSuccess();
    }
  }, [response, setShowModal, onSuccess]);

  useEffect(() => {
    if (configs?.strikeAppointment !== undefined) {
      form.setFieldsValue({
        strikeAppointment: configs.strikeAppointment,
      });
    }
  }, [configs, form]);

  const onSubmit = async (values) => {
    setIsLoading(true);
    if (configId) {
      setResponse(await dispatch(updateConfigs(configId, values)));
    }
    setIsLoading(false);
  };

  return (
    <Card size="small" bordered style={cardConfig}>
      <Form form={form} onFinish={onSubmit} {...formConfig}>
        <Form.Item
          name="strikeAppointment"
          label="Limite de cancelación (strikes)"
          rules={[{ required: true, message: 'Campo requerido' }]}
        >
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            placeholder="Ingresa un valor"
          />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          loading={isLoading}
          className="btn-form"
        >
          {buttonLabel.save}
        </Button>
      </Form>
    </Card>
  );
};
